import { useCallback } from 'react';
import * as qs from 'query-string';

import { useHistory, useLocation } from 'ha/helpers/router';

const useQueryParams = () => {
  const { query, pathname } = useLocation();
  const { replace } = useHistory();

  const removeUpdateSearchAlertParam = useCallback((): void => {
    if (query?.updateSearchAlert) {
      const { updateSearchAlert, ...queryParams } = query;
      const queryParamsString = `?${qs.stringify({ ...queryParams })}`;

      replace({
        pathname,
        search: queryParamsString,
      });
    }
  }, [query, pathname, replace]);

  return {
    removeUpdateSearchAlertParam,
  };
};

export default useQueryParams;
